import { CheckboxField } from '@/components';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { type FC, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = {
  index: number;
};

export const AmountSearchValueIsNullField: FC<Props> = ({ index }) => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<ProjectSearchFormType>();
  const baseAmountYear = useWatch({
    control,
    name: `formulaConditions.${index}.baseAmountYear`,
  });

  const disabled = useMemo(() => {
    return !baseAmountYear;
  }, [baseAmountYear]);

  return (
    <CheckboxField
      // やりたくないが高さを揃えるため
      label=" "
      name={`formulaConditions.${index}.baseAmountValueIsnull`}
      text={t('threshold-none')}
      control={control}
      errors={{}}
      disabled={disabled}
      shouldCoexistOnChange
      onChange={(e) => {
        if (e.target.checked) {
          setValue(`formulaConditions.${index}.baseAmountValueFrom`, null);
          setValue(`formulaConditions.${index}.baseAmountValueTo`, null);
        }
      }}
    />
  );
};
